import { useDispatch, useSelector } from 'react-redux';
import {
  getSelectedRegion,
  getTheCountries,
} from '@app/redux/localization/selectors';
import { useLocation } from '@app/router';
import { useCallback, useEffect, useMemo } from 'react';
import { setShowWhereAreYouModal as setShowWhereAreYouModalAction } from '@app/redux/ui/actions';
import { DOM, isBrowser } from '@app/utils';
import isEmpty from 'lodash/isEmpty';
import { getShowWhereAreYouModal } from '@app/redux/ui/selectors';
import { useIsTransactionFlow } from '@app/transaction';
import { dateOrNow, isDateBetween } from '@app/datetime';

/**
 *
 */
const useShowWhereAreYou = () => {
  const dispatch = useDispatch();
  const countryList = useSelector(getTheCountries);
  const region = useSelector(getSelectedRegion);
  const showWhereAreYouModal = useSelector(getShowWhereAreYouModal);
  const isTransactionFlow = useIsTransactionFlow();

  const location = useLocation();

  const setShowWhereAreYouModal = useCallback(
    (value) => {
      dispatch(setShowWhereAreYouModalAction(value));
    },
    [dispatch],
  );

  const searchQuery = location?.search ? location.search : '';
  const sourceIsMobile = searchQuery.includes('source=mobile');
  const country = useMemo(
    () => countryList.find((country) => country.iso2 === region),
    [countryList, region],
  );

  //
  // Determine if we should force show the modal or not.
  useEffect(() => {
    const whereAreYouDates = {
      cookieSet: dateOrNow(DOM.getCookie('stockx_dismiss_modal_set')),
      cookieExpires: dateOrNow(
        DOM.getCookie('stockx_dismiss_modal_expiration'),
      ),
      langUpdate: dateOrNow(country?.preferredLanguageUpdatedAt),
      currencyUpdate: dateOrNow(country?.preferredCurrencyUpdatedAt),
    };

    if (!DOM.getCookie('stockx_dismiss_modal') || isEmpty(country)) {
      return undefined;
    }

    if (sourceIsMobile) {
      return undefined;
    }

    if (!isBrowser) {
      return undefined;
    }

    if (isTransactionFlow) {
      return undefined;
    }

    if (
      !isDateBetween(
        whereAreYouDates.currencyUpdate,
        whereAreYouDates.cookieSet,
        whereAreYouDates.cookieExpires,
      ) &&
      !isDateBetween(
        whereAreYouDates.langUpdate,
        whereAreYouDates.cookieSet,
        whereAreYouDates.cookieExpires,
      )
    ) {
      return undefined;
    }

    DOM.delCookie('stockx_dismiss_modal_set');
    DOM.delCookie('stockx_dismiss_modal_expiration');
    DOM.delCookie('stockx_dismiss_modal');
    setShowWhereAreYouModal(true);
  }, [country, setShowWhereAreYouModal, sourceIsMobile, isTransactionFlow]);

  return useMemo(
    () => showWhereAreYouModal && !sourceIsMobile && !isTransactionFlow,
    [showWhereAreYouModal, sourceIsMobile, isTransactionFlow],
  );
};

export default useShowWhereAreYou;
